/** Per-task state computed by `ChallengeProgressEvaluator`. */
export var ChallengeTaskState;
(function (ChallengeTaskState) {
    /** Earlier task not yet completed; user has not started this task. */
    ChallengeTaskState["PENDING"] = "PENDING";
    /** First incomplete task — what the panel shows. */
    ChallengeTaskState["ACTIVE"] = "ACTIVE";
    /** Goal conditions met. */
    ChallengeTaskState["COMPLETED"] = "COMPLETED";
    /**
     * Task left incomplete and will not be resumed (e.g. session TTL-expired).
     * Reserved for the funnel projection: never emitted to the panel today; the
     * evaluator does not produce it, the TTL slice (#903) will.
     */
    ChallengeTaskState["ABANDONED"] = "ABANDONED";
})(ChallengeTaskState || (ChallengeTaskState = {}));
//# sourceMappingURL=challenge-task-state.enum.js.map